import { useContext } from 'react'
import LinksCardContainer from './LinkCardContainer'
import { DashboardContext } from '../../context'

export default function StartLinkCard() {
    const dashboardContext = useContext(DashboardContext)
    return (
        <LinksCardContainer menu={{
            breadcrumbs: [],
            id: 0,
            label: 'Inicio',
            icon: 'home',
            items: dashboardContext?.appData.menu
        }} />
    )
}
